import chalk from 'chalk'

type LoggerInput = { [key: string]: any }

type LevelType = 'error' | 'info' | 'debug' | 'warn' | 'critical' | 'alert'

const colouriseLevel = (level: LevelType): string => {
  switch (level) {
    case 'info':
      return chalk.blue(level)
    case 'warn':
      return chalk.yellow(level)
    case 'error':
      return chalk.red(level)
    default:
      return chalk.whiteBright(level)
  }
}

const formatStack = (stack: string): string => {
  return stack ? `\n  ${chalk.redBright(stack)}` : ''
}
const formatDebugJson = (error: object): string => {
  return error ? `\n  ${chalk.redBright(JSON.stringify(error, null, 2))}` : ''
}

export const formatDevLogs = (obj: LoggerInput, debugLog = false) => {
  const { timestamp, label, level, message, stack } = obj
  const formattedError = debugLog ? formatDebugJson(obj.error) : ''
  return `${chalk.gray(timestamp)} [${chalk.yellow(
    obj.meta?.correlationId ?? 'NO_CORRELATION_ID'
  )}] [${chalk.blueBright(label)}] ${chalk.underline(colouriseLevel(level))}: ${chalk.whiteBright(
    message
  )} ${formatStack(stack)} ${formattedError}`
}
